import { render, staticRenderFns } from "./procSend.vue?vue&type=template&id=9d05265e&scoped=true"
import script from "./procSend.vue?vue&type=script&lang=js"
export * from "./procSend.vue?vue&type=script&lang=js"
import style0 from "./procSend.vue?vue&type=style&index=0&id=9d05265e&prod&scoped=true&lang=css"
import style1 from "./procSend.vue?vue&type=style&index=1&id=9d05265e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d05265e",
  null
  
)

export default component.exports